

/**
* $.fn.html5mediaplayer
*
* Plugin for wrapping html5media.js
*
* @version v1.0.002, 2013-1-14
* @author Fredi Quirino <fred@firefallpro.com>, Scott Park <scott@firefallpro.com>
* @link http://www.firefallpro.com/
* @license http://www.firefallpro.com/license.txt
* @copyright Copyright (c) 2013 Firefall Pro, LLC
*
* Todo:
*	- Ability to take a list of sources
*	- identify which methods need arguments and which only need a callback
*	- Separate test for Flowplayer instead of per-method tests
*/
/*jshint forin:true, noarg:true, noempty:true, eqeqeq:true, bitwise:true, strict:true, undef:true, unused:true, browser:true, sub:true, devel:true, jquery:true, es5:true, indent:4, maxerr:50 */
/*global html5media:true, $f:true, swfobject:true*/
(function ($) {
	'use strict';
	
	var defaults = {
		'default' : ['height', 'width', 'controls', 'poster', 'preload', 'class', 'mediagroup', 'loop', 'autoplay'],
		'url_html5media' : '//cdnjs.cloudflare.com/ajax/libs/html5media/1.1.8/html5media.min.js',
		'url_swfobject' : '//ajax.googleapis.com/ajax/libs/swfobject/2.2/swfobject.js',
		'flash' : false,
		'debug' : false,
		'script_path' : null,
		'plugin_name' : 'player.html5media'
	};
	
	var o = {};
	
	var methods = {
		/**
		* _log
		*
		* Prefixes all debugging logs with plugin name, If IE is present then it opts for using strings when available rather
		* than an object, IE7 and 8 do not show contents of consoled objects. Method concatenates first and second arguments
		* if they're string literals before passing them to console log, otherwise it passes the whole arguments array
		*/
		'_log' : function () {
			if (!$.fn.html5mediaplayer.debug) return;
			
			var ie = !$.support.opacity, args = arguments, str = '';
			
			if (ie && typeof arguments[0] === 'string' && typeof arguments[1] === 'string') str = arguments[0] + ' ' + arguments[1];
			else if (ie && typeof arguments[0] === 'string') str = arguments[0];
			
			console.log(defaults['plugin_name'], (ie) ? str : args);
		},
		/**
		* _script_path - Sets the absolute path to the current loaded script or parent script if it was loaded by another plugin
		*
		* @param {object} options Holds the options for player to be created or to be interacted with
		* @returns {string} returns the new absolute path
		*/
		'_script_path' : function (o) {
			// Determine path of current script
			if (o.script_path === null) {
				var $script = $('script[src*="' + o.plugin_name + '"]');
				if ($script.length === 0) return '/';
				return $script[0].src;
			} else {
				var a = document.createElement('a');
				a.href = o.script_path;
				return a.href;
			}
		},
		/**
		* _base_path - Accepts a path and trims the ending, returns the new path.
		*
		* @param {string} path Pathname that will be trimmed
		* @returns {string} returns the new pathname
		*/
		'_base_path' : function (path) {
			return path.substr(0, path.lastIndexOf('/'));
		},
		/**
		* _dependency
		*
		* Helps to load dependencies sequentially, but can also load asynchronous. Key of mapped objects must
		* be the name of the file e.g 'swfobject.js' : {}. Queues dependencies on 'body' and adds the callback
		* if any as the last queued function.
		*
		* @param {object} dependencies An object that holds a map of dependencies that need to be loaded and their settings
		*	@param {boolean} dependencies.async 
		*	If 'false' it will load dependencies sequentially and wait until it gets a result before 
		*	going on to the next dependency, otherwise if 'true' it will not wait for the results and trigger the next dependency
		*	
		*	@param {string} dependencies.url
		*	This is the location to the dependency,  if omitted the url will be constructed using
		*	the path in 'options.script_path' along with the filename/key
		*	
		*	@param {function} dependencies.test A function that returns either true or false, used to test if dependency has already been loaded
		*	@param {function} dependencies.callback A function to be called after dependency is loaded successfully
		* @param {object} options Holds the options for player to be created
		* @param {function} callback Supplies a function to be called at completion, optionally
		*/
		'_dependency' : function (dependencies, options, callback) {
			
			var $body = $('body'),
			queue_hold = ($body.queue('player').length) ? true : false;
			
			
			$.each(dependencies, function (filename, file) {
				
				// Dependency state
				if (typeof dependency[filename] === 'undefined') dependency[filename] = 0;
				
				// Check if already loaded
				if (dependency[filename] === 2 || file.test()) {
					methods._log(filename + ' is already loaded');
					dependency[filename] = 2;
					if (typeof file.callback !== 'undefined') file.callback();
					return;
				}
				
				// URL
				if (file.url === null) file.url = methods._base_path(options.script_path) + '/' + filename;
				
				methods['_log']('load script at ' + file.url);
				
				// Queue
				$body.queue('player', function (next) {
					
					if (dependency[filename] === 0) {
						// Signal loading
						methods._log('Loading ' + filename);
						
						dependency[filename] = 1;
						
						// Load Script
						dependency[filename + '_promise'] = $.ajax({
							'cached' : true,
							'dataType' : 'script',
							'error' : function () {
								$.error('Failed to load dependency: ' + file.url);
							},
							'success' : function () {
								methods._log(filename + ' loaded');
								
								dependency[filename] = 2;
								if (typeof file.callback !== 'undefined') file.callback();
								if (!file.async) next();
							},
							'url' : file.url
						});
						if (file.async) next();
						return;
					}
						
					methods._log(filename + 'has already been started');
					
					dependency[filename + '_promise'].done(function () {
						methods._log(filename + ' was added to .done()');
						if (typeof file.callback !== 'undefined') file.callback();
						if (!file.async) next();
					});
					
					if (file.async) next();
					
				});
			});
			
			// Queue callback if set
			if (typeof callback !== 'undefined') {
				$body.queue('player', function (next) {
					methods['_log']('Queue is complete');
					
					callback();
					next();
				});
			}
			
			// Start queue
			if (!queue_hold) $body.dequeue('player');
		},
		/**
		* _configure_html5media
		*
		* configures properties for flow player that html5media uses for fallback
		*
		* @param {object} options Holds the options that will be used to configure.
		* @returns {obect} returns jQuery object
		*/
		'_configure_html5media' : function (o) {			
			// Check if html5media isn't loaded
			if (typeof window.html5media === 'undefined') {
				$.error('_configure_html5media: Called before html5media loaded');
				
			// Configure html5media
			} else {
				methods._log('Configuring html5media');
				
				// Set paths for html5media dependencies
				var path = o['url_html5media'];
				path = path.slice(0, path.lastIndexOf('/') + 1);
				html5media.flowplayerSwf = path + 'flowplayer.swf';
				html5media.flowplayerControlsSwf = path + 'flowplayer.controls.swf';
				html5media.flowplayerAudioSwf = path + 'flowplayer.audio.swf';
				
				// Configure Flowplayer
				html5media.configureFlowplayer = function (element, config) {
					return $.extend(config, {
						'debug' : false,
					
						// Player Events: http://flash.flowplayer.org/documentation/events/player.html
						'onVolume' : function () {
							$(this.getParent()).trigger('volumechange', arguments);
						},
						'onMute' : function () {
							$(this.getParent()).trigger('volumechange', arguments);
						},
						'onUnmute' : function () {
							$(this.getParent()).trigger('volumechange', arguments);
						},
						'onError' : function () {
							$(this.getParent()).trigger('error', arguments);
						},
						
						// Clip Events: http://flash.flowplayer.org/documentation/events/player.html
						'onBegin' : function () {
							$(this.getParent()).trigger('loadstart');
						},
						'onLoad' : function () {
							$(this.getParent()).trigger('loadstart');
						},
						'onFinish' : function () {
							// Bug: onFinish fires once initially
							if (this.getTime() !== 0) $(this.getParent()).trigger('ended');
						},
						'onMetaData' : function () {
							$(this.getParent()).trigger('loadedmetadata');
						},
						'onPause' : function () {
							$(this.getParent()).trigger('pause');
						},
						'onResume' : function () {
							// Bug: onResume fires once initially
							if (this.getTime() !== 0) $(this.getParent()).trigger('play');
						},
						'onBeforeSeek' : function () {
							$(this.getParent()).trigger('seeking');
						},
						'onSeek' : function () {
							$(this.getParent()).trigger('seeked');
						},
						'onStart' : function () {
							// Bug: onStart fires once initially
							if (this.getStatus()['bufferEnd'] !== 0) $(this.getParent()).trigger('playing');
						},
						'clip' : {
							'autoBuffering' : true,
							'bufferLength' : 3,
							'autoPlay' : true,
							'metaData' : false
							
						},
						'onBeforeLoad' : function () {
							$(this.getParent()).trigger('onbeforeload');
						},
						'onBufferFull' : function () {
							$(this.getParent()).trigger('bufferfull');
						}
					});
				};
				
				// Flash fallback toggle
				html5media.forceFallback = function () {
					return o['flash'];
				};
			}
			
			return this;
		},
		/**
		* init
		*
		* initiates dependencies, gets an absolute path to dependencies using the path in the script tag and
		* sequentially loads dependencies after each one.
		*
		* @param {string} args
		* @param {object} options Holds the options that will be used to configure the loading and creation of the player
		* @param {function} callback Supplies a function to be called at completion, optionally
		* @returns {obect} returns jQuery object
		*/
		'init' : function (args, options, callback) {
			var $this = this;
			
			// Signal initialization in progress
			dependency.inited = 1;
			
			// Merge specified options with defaults
			o = $.extend({}, defaults, options);
			
			// Debug mode toggle
			if (o['debug']) $.fn.html5mediaplayer.debug = true;
			
			// ST COMMENTED OUT FOR SUPREME BOUTIQUE
			//if (o['url_html5media'] === defaults['url_html5media']) o['url_html5media'] = //methods._base_path(methods._base_path(methods['_script_path'](o))) + '/' + o['url_html5media'];
			if (o['url_html5media'] === defaults['url_html5media']) o['url_html5media'] = defaults['url_html5media'];	
			if (o['url_html5media']	!== defaults['url_html5media'])	o['url_html5media'] = defaults['url_html5media'];		

			methods['_log']('script_path is ', o['script_path']);
			
			methods['_log']('url is ', o['url_html5media']);
			
			var dependencies = {
				'html5media.min.js' : {
					'url' : o['url_html5media'],
					'async' : false,
					'test' : function () { return (typeof window.html5media !== 'undefined'); },
					'callback' : function () {
						methods['_configure_html5media'](o);
					}
				},
				'swfobject.js' : {
					'url' : o['url_swfobject'],
					'async' : true,
					'test' : function () { return (typeof swfobject !== 'undefined'); }
				}
			};
				
			methods['_dependency'](dependencies, o, function () {
				dependency.inited = 2;
				if (typeof callback !== 'undefined') callback.call($this);
			});
			
			return this;
		},
		/**
		* player - Creates the video tag with the needed attributes for video playback and triggers 'init.player' event on target
		*
		* @param {string} args The source of the video that should be loaded, also used as a base for multiple types of sources.
		* @param {object} o An object of properties for the player that will be created
		* @param {function} callback Optional, called after player has been created
		*/
		'player' : function (args, settings, callback) {
			var a = document.createElement('a'), path, absolute_path, ext, types, $video = $(document.createElement('video')), attributes = {}, source = document.createElement('source');

			// Input validation
			if (typeof args !== 'string') {
				$.error('No video URL specified');
				return this;
			}
			
			a.href = args;
			if (methods['videoplayer_mime'](a.pathname) === false) {
				$.error('Unsupported video type');
				return this;
			}
			
			methods._log('Creating Player for ' + a.href);
			
			// File source without extension
			path = (a.pathname.charAt(0) === '/') ? a.pathname : '/' + a.pathname;
			path = path.split('.');
			ext = path.pop();
			//path = ((a.protocol === ':') ? '' : a.protocol) + '//' + a.hostname + path.join('.') + '.';
			absolute_path = ((a.protocol === ':') ? '' : a.protocol) + '//' + a.hostname;
			absolute_path += (a.port ? ':' + a.port : '') + path.join('.') + '.';
			path = absolute_path;
			
			
			var new_o = $.extend({}, o, settings);
			
			// Set VIDEO element attributes
			$.each(o['default'], function (i, value) {
				if (typeof new_o[value] === 'undefined') return;
				attributes[value] = new_o[value];
			});
			
			// Controls attribute causes video to have controls just by being there
			if(o['controls']) attributes.controls = 'controls';
			else delete attributes.controls;

			attributes['id'] = 'player_' + (new Date()).getTime();
			
			// Assemble video
			$video.attr(attributes);
			
			// Set initial source
			source.src = path + ext;
			source.type = methods['videoplayer_mime'](a.pathname);
			$video.append(source);
			
			// Expand additional types into sources
			if (typeof o['types'] === 'string') {
				types = o['types'].split(',');
				$.each(types, function (i, type) {
					type = $.trim(type);
					
					// Validate Input
					if (ext === type || typeof methods['videoplayer_mime'](type) === 'undefined') return;
					
					// Add Source
					source = document.createElement('source');
					source.src = path + type;
					source.type = methods['videoplayer_mime'](type);
					$video.append(source);
				});
			}
			
			// Image fallback
			if (typeof o['poster'] === 'string') {
				var img = document.createElement('img');
				img.src = o['poster'];
				img.alt = 'No video playback available';
				$video.append(img);
			}
			
			// Proxy known events
			$video.on('init loadstart progress suspend abort error emptied stalled loadedmetadata loadeddata canplay canplaythrough playing waiting seeking seeked ended durationchange timeupdate play pause ratechange volumechange readystatechange', function (e, arg) {
				
				// Debug
				methods._log('event', e.type, arg);
				
				// Namespace events to the container
				$(this).parent().trigger(e.type + '.player', arg);
			});
			
			// Add video to target
			this.append($video);
			
			this.data('player', {'type' : 'html5media'});
			
			// Re-initialize html5media
			html5media();
			
			// Trigger Element video.init
			this.trigger('init.player');
			
			methods._log('player initialized');
			// callback
			if (typeof callback !== 'undefined') callback.call(this);
		},
		/**
		* videoplayer_mime - codecs and mime associated with extensions that are supported.
		*
		* @param {string} file The source url for a video.
		* @returns {object} returns undefined if supported extension is not found
		*/
		'videoplayer_mime' : function (file) {			
			// Known MIME types
			var type = {
				'mp4' : 'video/mp4; codecs="avc1.42E01E, mp4a.40.2"',
				'webm' : 'video/webm; codecs="vp8, vorbis"',
				'ogg' : 'video/ogg; codecs="theora, vorbis"',
				'ogv' : 'video/ogg; codecs="theora, vorbis"',
				'theora.ogg' : 'video/ogg; codecs="theora, vorbis"',
				'theora.ogv' : 'video/ogg; codecs="theora, vorbis"'
			};
			
			// Extract and map file extension
			return type[file.split('.').pop()];
		},
		/**
		* play - plays the video
		*
		* @param {string} args 
		* @param {object} settings A plugin options object, optionally
		* @param {function} callback Supplies a function to be called at completion, optionally
		*
		* @returns {object} returns a jQuery object
		*/
		'play' : function (args, settings, callback) {
			var player = this.children()[0];
			
			// Flowplayer
			if (typeof $f() !== 'undefined' && $f(player) !== null) {
				$f(player).play();
				
			// Native player
			} else if (typeof player.play !== 'undefined') {
				player.play();
			}
			
			// Callback
			if (typeof callback !== 'undefined') callback.call(this);
			return this;
		},
		/**
		* pause - pauses the video
		*
		* @param {string} args 
		* @param {object} settings A plugin options object, optionally
		* @param {function} callback Supplies a function to be called at completion, optionally
		*
		* @returns {object} returns a jQuery object
		*/
		'pause' : function (args, settings, callback) {
			var player = this.children()[0];
			
			// Flowplayer
			if (typeof $f() !== 'undefined' && $f(player) !== null) {
				$f(player).pause();
			
			// Native player
			} else if (typeof player.pause !== 'undefined') {
				player.pause();
			}
			
			// Callback
			if (typeof callback !== 'undefined') callback.call(this);
			return this;
		},
		/**
		* stop - stops the video
		*
		* @param {string} args 
		* @param {object} settings A plugin options object, optionally
		* @param {function} callback Supplies a function to be called at completion, optionally
		*
		* @returns {object} returns a jQuery object
		*/
		'stop' : function (args, settings, callback) {
			var player = this.children()[0];
			
			// Flowplayer
			if (typeof $f() !== 'undefined' && $f(player) !== null) {
				$f(player).stop();
			
			// Native player
			} else if (typeof player.currentTime !== 'undefined' && player.readyState !== 0) {
				player.pause();
				player.currentTime = 0;
			}
			
			// callback
			if (typeof callback !== 'undefined') callback.call(this);
			return this;
		},
		/**
		* destroy - destroys the video
		*
		* @param {string} args 
		* @param {object} settings A plugin options object, optionally
		* @param {function} callback Supplies a function to be called at completion, optionally
		*
		* @returns {object} returns a jQuery object
		*/
		'destroy' : function (args, settings, callback) {
			var player = this.children()[0];
			
			// Stop first
			methods['stop'].call(this, args, settings, function () {
				
				// Flowplayer
				if (typeof $f() !== 'undefined' && $f(player) !== null) {
					$f(player).close();
					
					// Use SWF Object, Flowplayer $f().unload() is unreliable in IE
					swfobject.removeSWF(this.find('span > object').attr('id'));
				
				// Native player
				} else {
					// All sources must be changed to dereference and halt the loaded video in Chrome
					// Bug: http://code.google.com/p/chromium/issues/detail?id=31014
					this.find('video, source').attr('src', '#');
				}
				
				// Flush element
				this.removeClass('video').removeData('player').empty();
				methods._log('destroyed');
				
				// Callback
				if (typeof callback !== 'undefined') callback.call(this);
			});
			
			return this;
		},
		'mute' : function (force, settings, callback) {
			var player = this.children()[0];
			
			// Flowplayer
			if (typeof $f() !== 'undefined' && $f(player) !== null) {
				
				$f(player).mute();
			// Native player
			} else {
				player.muted = !player.muted;
			}
			
			// callback
			if (typeof callback !== 'undefined') callback.call(this);
			return this;
		
		}
		/*,
		'seekTo' : function (args, settings, callback) {
			var player = this.children()[0];
			
			// Flowplayer
			if (typeof $f() !== 'undefined' && $f(player) !== null) {
				
			
			// Native player
			} else if (player.readyState !== 0) {
				args = (args > player.duration) player.duration : args;
				args = (args < 0) 0 : args;

				player.currentTime = args;
			}
			
			// callback
			if (typeof callback !== 'undefined') callback.call(this);
			return this;
		}
		*/
	};
	
	$.fn.html5mediaplayer = function () {
		var fn = 'init', args, settings = {}, callback;
		
		// Assign arguments
		for (var i = 0; i < arguments.length; i++) {
			switch (typeof arguments[i]) {
			
			// Callback
			case 'function':
				callback = arguments[i];
				break;
			
			// Settings
			case 'object':
				settings = arguments[i];
				break;
			
			// Ignore undefined
			case 'undefined':
				break;
			
			// Function or Argument
			case 'string':
			default:
				if (methods[arguments[i]]) fn = arguments[i];
				else args = arguments[i];
			}
		}
		
		methods._log(fn);
		
		// Initialize
		if ($.fn.html5mediaplayer.dependencies.inited !== 2) {
			methods['init'].call(this, null, settings, function () {
				if (fn !== 'init') this.html5mediaplayer(fn, args, settings, callback);
			});
		
		// Initialized
		} else {
			this.each(function () {
				methods[fn].call($(this), args, settings, callback);
			});
		}
		
		return this;
	};
	
	// Dependency tracker
	var dependency = $.fn.html5mediaplayer.dependencies = {
		'inited' : 0
	};
	
	// Debug state
	$.fn.html5mediaplayer.debug = false;
})(jQuery);
